import { render, staticRenderFns } from "./SVC95010.vue?vue&type=template&id=058a70be&"
import script from "./SVC95010.vue?vue&type=script&lang=js&"
export * from "./SVC95010.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports